import React from 'react';
import { useDispatch } from 'react-redux';

import BrandedColorInput from '../common/inputs/customs/branded-color';
import InpageSkin from '../common/inputs/customs/inpage-skin';
import AvatarsStyle from '../common/inputs/customs/avatars-style';
import { useCurrentSpot } from '../../../spots/hooks/useCurrentSpot';
import { EditSpotData } from '../../../spots/spotsTypes';
import { editSpot } from '../../../spots/spotsActions';

export const Design = () => {
  const spot = useCurrentSpot();
  const dispatch = useDispatch();

  const onEditSpot = (data: EditSpotData) => {
    dispatch(editSpot({ spotId: spot.id, data }));
  };

  if (!spot) {
    return null;
  }

  const { id, name, brandColor, inpageSkin, avatarsStyle } = spot;

  return (
    <div className="preferences-design">
      <div className="fields">
        <BrandedColorInput
          autoSave
          showValidationTooltip
          spotId={id}
          spotName={name}
          value={brandColor}
          validate
          editSpot={onEditSpot}
        />
        <InpageSkin autoSave isExpanded value={inpageSkin} validate editSpot={onEditSpot} />
        <AvatarsStyle value={avatarsStyle} editSpot={onEditSpot} />
      </div>
    </div>
  );
};
